import email from "../Assets/email.png";
import mobile from "../Assets/mobile.png";
import api from "../Assets/api.png";
import cpp from "../Assets/cpp.png";
import css from "../Assets/css.png";
import figma from "../Assets/figma.png";
import flutter from "../Assets/flutter.png";
import git from "../Assets/git.png";
import graphql from "../Assets/graphql.png";
import html from "../Assets/html.png";
import javascript from "../Assets/javascript.png";
import mu5 from "../Assets/mu5.png";
import node from "../Assets/node.png";
import python from "../Assets/python.png";
import react from "../Assets/react.png";
import redux from "../Assets/redux.png";
import sass from "../Assets/sass.png";
import typescript from "../Assets/typescript.png";
import vue from "../Assets/vue.png";

import about01 from "../Assets/about01.png";
import about02 from "../Assets/about02.png";
import about03 from "../Assets/about03.png";
import about04 from "../Assets/about04.png";

import profile from "../Assets/profile.png";
import circle from "../Assets/circle.svg";
import logo from "../Assets/logo.png";

import adidas from "../Assets/adidas.png";
import amazon from "../Assets/amazon.png";
import asus from "../Assets/asus.png";
import bolt from "../Assets/bolt.png";
import nb from "../Assets/nb.png";
import skype from "../Assets/skype.png";
import spotify from "../Assets/spotify.png";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
};
